import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import { GetUploadUrl } from "../../api/orgService";
import useApi from "../../api/useApi";

export default function AddSectionForm({ onAddSection }) {
  const [open, setOpen] = useState(false);
  const [section, setSection] = useState({
    type: "text",
    heading: "",
    value: "",
  });

  const { request:getUploadUrl,data:getUploadUrlData,error:getUploadUrlError}=useApi(GetUploadUrl)

  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setSection((prev) => ({ ...prev, [name]: value }));
  };


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Convert to local preview URL
      const previewUrl = URL.createObjectURL(file);
      setSection((prev) => ({ ...prev, value: previewUrl }));
      const formData = new FormData();
      formData.append("image", file);

      try{
        // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
        // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
          const res = await fetch("/cms/ftp-files/", {
          method: "POST",
          body: formData, // don't add headers here
        });
      // console.log(res)
      if(res?.status===201){
        let result = await res.json()
        console.log("Upload urls: ",result)
        setSection((prev) => ({ ...prev, value: result?.path }));
      // setMaterialUrl(event,event.target.value)
        // setUploadUrls(prev=>res?.data)
      }else{
        console.log(res)
      }
      }catch(error){
        console.log(error)
      }
    }
  };


  const handleSubmit = () => {
    if (!section.value) return alert("Please provide a value.");
    onAddSection(section);
    setSection({ type: "text", heading: "", value: "" });
    setOpen(false);
  };

  return (
    <>
      {/* Add Section Button */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        Add Section
      </Button>

      {/* Popup Form */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Section</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography
            sx={{
                mb:5,
            }}
            >A section is a paragragh either consisting of a subheading (optional), text content or even image/video. 
                This makes it easy to organize and present your content in paragrphs to the reader.
            </Typography>
            {/* Type Selector */}
            <TextField
              select
              name="type"
              label="Section Type"
              value={section.type}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem value="text">Text</MenuItem>
              <MenuItem value="image">Image</MenuItem>
              <MenuItem value="video">Video</MenuItem>
            </TextField>

            {/* Optional Heading */}
            <TextField
              name="heading"
              label="Heading (optional)"
              value={section.heading}
              onChange={handleChange}
              fullWidth
            />

            {/* Value Input — varies by type */}
            {section.type === "text" ? (
              <TextField
                name="value"
                label="Text Content"
                value={section.value}
                onChange={handleChange}
                multiline
                rows={4}
                fullWidth
              />
            ) : 
            (
                <>
                  <Tabs
                    value={tabIndex}
                    onChange={(e, newValue) => setTabIndex(newValue)}
                    centered
                    sx={{ mb: 1 }}
                  >
                    <Tab label="Link" />
                    <Tab label="Upload" />
                  </Tabs>
  
                  {tabIndex === 0 ? (
                    <TextField
                      name="value"
                      label={
                        section.type === "image"
                          ? "Image URL or Path"
                          : "Video URL (YouTube embed, etc.)"
                      }
                      value={section.value}
                      onChange={handleChange}
                      fullWidth
                    />
                  ) : (
                    <Box
                      sx={{
                        border: "2px dashed #ccc",
                        borderRadius: 2,
                        p: 3,
                        textAlign: "center",
                      }}
                    >
                      {section.value ? (
                        section.type === "image" ? (
                          <img
                            src={section.value}
                            alt="preview"
                            style={{
                              width: "100%",
                              borderRadius: "8px",
                              marginBottom: "8px",
                            }}
                          />
                        ) : (
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            File selected: {section.value.split("/").pop()}
                          </Typography>
                        )
                      ) : (
                        <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                      )}
  
                      <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                      >
                        {section.value ? "Change File" : "Upload File"}
                      </Button>
                      <input
                        type="file"
                        accept={section.type === "image" ? "image/*" : "video/*"}
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
                    </Box>
                  )}
                </>
              )
            }
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
